import React from 'react';

const LogoIcon = () => {
	return (
		<svg
			data-testid='logo'
			fill='none'
			height='30'
			viewBox='0 0 30 30'
			width='30'
		>
			<path
				d='M20.19 14.3511C20.129 13.6911 19.9394 13.0615 19.6474 12.4908L20.5582 11.6282L19.9721 10.8962L19.3859 10.1643L18.3443 10.8657C17.8496 10.4562 17.2765 10.136 16.6446 9.93121L16.6773 8.67864L15.7446 8.57626L14.812 8.47388L14.5723 9.70466C13.912 9.76565 13.2823 9.95517 12.7114 10.2471L11.8484 9.33651L11.1163 9.92249L10.3841 10.5085L11.0858 11.5497C10.6761 12.0442 10.3558 12.6171 10.1509 13.2489L8.90015 13.214L8.79773 14.1464L8.69531 15.0787L9.92649 15.3183C9.98751 15.9784 10.1771 16.6079 10.4691 17.1787L9.55823 18.0413L10.1444 18.7732L10.7306 19.5052L11.7722 18.8037C12.2668 19.2133 12.8399 19.5335 13.4719 19.7382L13.4392 20.9908L14.3718 21.0932L15.3045 21.1956L15.5442 19.9648C16.2044 19.9038 16.8342 19.7143 17.4051 19.4224L18.268 20.3329L19.0002 19.747L19.7324 19.161L19.0307 18.1197C19.4404 17.6252 19.7607 17.0523 19.9655 16.4206L21.2185 16.4533L21.3209 15.5209L21.4233 14.5886L20.19 14.3511ZM14.7248 17.867C13.0491 17.6819 11.8397 16.1744 12.0228 14.4993C12.208 12.8241 13.7159 11.6151 15.3916 11.7981C17.0673 11.9832 18.2767 13.4907 18.0937 15.1658C17.9085 16.8432 16.4005 18.0522 14.7248 17.867Z'
				fill='#2694C4'
			/>
			<path
				d='M15.0578 17.0109C16.2444 17.0109 17.2063 16.0493 17.2063 14.863C17.2063 13.6768 16.2444 12.7151 15.0578 12.7151C13.8711 12.7151 12.9092 13.6768 12.9092 14.863C12.9092 16.0493 13.8711 17.0109 15.0578 17.0109Z'
				fill='#DA386C'
			/>
			<path
				d='M4.52842 15.0003C4.52842 13.861 4.71146 12.7653 5.04922 11.7371L0.765146 10.3451C-1.27883 16.6362 0.85231 23.1953 6.20195 27.0837L8.83211 23.4633C6.22375 21.5572 4.52842 18.477 4.52842 15.0003Z'
				fill='#2694C4'
			/>
			<path
				d='M15.0013 25.4739C12.6936 25.4739 10.5625 24.7267 8.8323 23.4633L6.20215 27.0837C11.5518 30.9721 18.4464 30.9721 23.7982 27.0837L21.1681 23.4633C19.4401 24.7289 17.3089 25.4739 15.0013 25.4739Z'
				fill='#8F3E8D'
			/>
			<path
				d='M29.2349 10.3451L24.953 11.7371C25.2908 12.7653 25.4738 13.861 25.4738 15.0003C25.4738 18.4791 23.7785 21.5594 21.168 23.4633L23.7981 27.0837C29.1478 23.1953 31.2789 16.6362 29.2349 10.3451Z'
				fill='#DC396D'
			/>
			<path
				d='M15.0012 4.52448C19.647 4.52448 23.5824 7.55024 24.9531 11.7371L29.235 10.3451C27.191 4.05395 21.6125 0 14.999 0L15.0012 4.52448Z'
				fill='#6EBD45'
			/>
			<path
				d='M3.67676 7.90314H5.41131'
				stroke='#DA386C'
				strokeMiterlimit='18.5946'
				strokeWidth='1.8'
			/>
			<path
				d='M6.89062 4.3894H8.62518'
				stroke='#DA386C'
				strokeMiterlimit='18.5946'
				strokeWidth='1.8'
			/>
			<path
				d='M10.9805 1.83203H12.715'
				stroke='#E17F9F'
				strokeMiterlimit='18.5946'
				strokeWidth='1.8'
			/>
		</svg>
	);
};

export default LogoIcon;
